import React from 'react';

import { AssetsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <AssetsIcon size="xsmall" label="" />;

export const useAssets = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ASSETS,
		analyticsName: Products.ASSETS,
		...options,
	});
